"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMission = exports.getSurvivalTime = exports.addShipsDead = exports.addAlienDead = exports.addDeadLog = exports.networkUpdate = exports.update = exports.reset = exports.get = void 0;
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
var voyageMission_sidecar_1 = require("@voyage/missions/voyageMission-sidecar");
var voyageMissionData_1 = require("@voyage/missions/voyageMissionData");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageMessageShipStatus_sidecar_1 = require("@voyage/multi/voyageMessageShipStatus-sidecar");
var voyageTestParams_sidecar_1 = require("@voyage/scene/voyageTestParams-sidecar");
var voyageSoundsAmbient_sidecar_1 = require("@voyage/sounds/voyageSoundsAmbient-sidecar");
var voyageUiMessage_sidecar_1 = require("@voyage/ui/voyageUiMessage-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        reset();
    }
    return _obj;
}
exports.get = get;
function create() {
    var nullMission = voyageMission_sidecar_1.voyageMission.create(voyageMissionData_1.EVoyageMissionType.Null);
    var obj = {
        currentMission: nullMission,
        hasFire: {
            isActive: false,
            willBeActive: false,
        },
        hasBoarders: {
            isActive: false,
            willBeActive: false,
        },
        hasBreach: {
            isActive: false,
            willBeActive: false,
        },
        hasReactorRunning: {
            isActive: false,
            willBeActive: false,
        },
        breachCount: 0,
        fireCount: 0,
        crewCount: 0,
        statusTimer: 0,
        oxygen: 100,
        addOxygen: 0,
        power: 100,
        addPower: 0,
        jumpCharge: 50,
        addJumpCharge: 0,
        money: 0,
        enemyShip: voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.create(),
        isGameStarted: false,
        isGameEnded: false,
        survivalTime: 0,
        isAtStarbase: true,
        locationName: 'Starting lcoation',
        shipFilename: '',
    };
    return obj;
}
function reset() {
    var obj = get();
    var nullMission = voyageMission_sidecar_1.voyageMission.create(voyageMissionData_1.EVoyageMissionType.Null);
    obj.currentMission = nullMission;
    obj.breachCount = 0;
    obj.fireCount = 0;
    obj.crewCount = 0;
    obj.statusTimer = 0;
    obj.oxygen = 100;
    obj.addOxygen = 0;
    obj.power = 100;
    obj.addPower = 0;
    obj.money = 500;
    obj.jumpCharge = 50;
    obj.addJumpCharge = 0;
    obj.isGameEnded = false;
    obj.enemyShip.active = false;
    obj.survivalTime = 0;
    obj.isAtStarbase = true;
    obj.locationName = 'Starbase-7';
    _reset(obj.hasFire);
    _reset(obj.hasBoarders);
    _reset(obj.hasBreach);
    _reset(obj.hasReactorRunning);
}
exports.reset = reset;
function _flip(f) {
    f.isActive = f.willBeActive;
    f.willBeActive = false;
}
function _reset(f) {
    f.isActive = false;
    f.willBeActive = false;
}
function update() {
    var obj = get();
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    obj.statusTimer += ds;
    if (!obj.isGameEnded && obj.isGameStarted) {
        obj.survivalTime += ds;
    }
    if (voyageTestParams_sidecar_1.voyageTestParams.test_freeJumps) {
        obj.jumpCharge = 200;
    }
    var updateTime = 2;
    if (obj.statusTimer > updateTime) {
        obj.statusTimer -= updateTime;
        if (obj.isGameStarted) {
            if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                obj.power -= 1;
                obj.jumpCharge -= 1;
                obj.oxygen -=
                    (obj.crewCount + 2) * 0.25 +
                        (obj.breachCount * 1 + obj.fireCount * 2) * 0.25 * 0.5;
                obj.power += obj.addPower;
                obj.oxygen += obj.addOxygen;
                obj.jumpCharge += obj.addJumpCharge;
            }
        }
        obj.addPower = 0;
        obj.addOxygen = 0;
        obj.addJumpCharge = 0;
        // console.log('status', obj.power, obj.oxygen, obj.jumpCharge)
        if (obj.isGameStarted && !obj.isGameEnded) {
            var liveCount = diveCrew_hero_sidecar_1.diveCrew_hero.countLiveHeroes();
            if (liveCount <= 0) {
                obj.isGameEnded = true;
                var text = 'Everyone is dead, thanks for playing!';
                text += '\n\nIn loving memory of:';
                // l.forEach(_deadLog, (c) => {
                //   text += + c
                // })
                text += _deadLog;
                text += '\n';
                text +=
                    '\nKilled ' +
                        _alienDead +
                        ' slimy alien' +
                        (_alienDead !== 1 ? 's' : '');
                text +=
                    '\nDestroyed ' +
                        _shipsDead +
                        ' enemy spaceship' +
                        (_alienDead !== 1 ? 's' : '');
                text += '\n\n' + 'Survived: ' + getSurvivalTime();
                text += '\n\n by Keep Flying Games';
                text += '\n https://keepflyinggames.com';
                text += '\n\nHit F5 to retry';
                voyageUiMessage_sidecar_1.voyageUiMessage.setText('The End of the Voyage', text);
                voyageUiMessage_sidecar_1.voyageUiMessage.setOpen(true);
            }
        }
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            obj.power = mathUtils_sidecar_1.mathUtils.clamp(obj.power, 0, 100);
            obj.oxygen = mathUtils_sidecar_1.mathUtils.clamp(obj.oxygen, 0, 100);
            obj.jumpCharge = mathUtils_sidecar_1.mathUtils.clamp(obj.jumpCharge, 0, 125);
            voyageMessageShipStatus_sidecar_1.voyageMessageShipStatus.sendMessageAndImmediatelyExecute({
                oxygen: obj.oxygen,
                power: obj.power,
                jump: obj.jumpCharge,
            });
        }
    }
    voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.update();
    voyageSoundsAmbient_sidecar_1.voyageSoundsAmbient.updateFire(obj.hasFire.isActive);
    voyageSoundsAmbient_sidecar_1.voyageSoundsAmbient.updateReactor(obj.hasReactorRunning.isActive);
    _flip(obj.hasFire);
    _flip(obj.hasBoarders);
    _flip(obj.hasBreach);
    _flip(obj.hasReactorRunning);
    obj.fireCount = 0;
    obj.breachCount = 0;
    obj.crewCount = 0;
    return obj;
}
exports.update = update;
function networkUpdate(msg) {
    var obj = get();
    obj.power = msg.power;
    obj.oxygen = msg.oxygen;
    obj.jumpCharge = msg.jump;
}
exports.networkUpdate = networkUpdate;
var _deadLog = '';
var _alienDead = 0;
var _shipsDead = 0;
// export function getDeadLog() {
//   return { _deadLog, _alienDead, _shipsDead }
// }
function addDeadLog(text) {
    _deadLog += '\n' + text;
}
exports.addDeadLog = addDeadLog;
function addAlienDead() {
    _alienDead++;
}
exports.addAlienDead = addAlienDead;
function addShipsDead() {
    _shipsDead++;
}
exports.addShipsDead = addShipsDead;
function getSurvivalTime() {
    var obj = get();
    var s = Math.floor(obj.survivalTime);
    var secondsInMinute = 60;
    var secondsInHour = 60 * 60;
    var rs = s;
    var hours = Math.floor(rs / secondsInHour);
    rs -= hours * secondsInHour;
    var minutes = Math.floor(rs / secondsInMinute);
    rs -= minutes * secondsInMinute;
    var sHours = '' + hours;
    var sMinutes = '' + minutes;
    if (sMinutes.length === 1) {
        sMinutes = '0' + sMinutes;
    }
    var sSeconds = '' + rs;
    if (sSeconds.length === 1) {
        sSeconds = '0' + sSeconds;
    }
    return sHours + ':' + sMinutes + ':' + sSeconds;
}
exports.getSurvivalTime = getSurvivalTime;
function setMission(type) {
    var obj = get();
    console.log('set mssion type', type);
    obj.currentMission = voyageMission_sidecar_1.voyageMission.create(type);
}
exports.setMission = setMission;
